<div class="container">
  <form [formGroup]="checkoutForm" (ngSubmit)="onSubmit()">
    <div class="mt-5 row justify-content-center">
      <div class="col-3">
        <p class="text-center" [innerHTML]="'bank365.bankInfo' | translate: {bankTitle}"></p>
        <p class="text-start fw-bold">{{ 'bank365.smsTitle' | translate }}</p>
      </div>
    </div>
    <div class="mb-3 row justify-content-center">
      <div class="col-3">
        <label for="sms" class="form-label">{{ 'bank365.sms' | translate }}</label>
        <input type="text" class="form-control" id="sms" formControlName="sms" aria-describedby="smsHelp">
        <div id="smsHelp" class="form-text">{{ 'bank365.smsHelp' | translate }}</div>
      </div>
    </div>
    <div class="mb-3 row justify-content-center">
      <div class="col-3 d-flex justify-content-between">
        <button type="button" class="btn btn-light" (click)="cancel()">{{ 'bank365.cancel' | translate }}</button>
        <button type="submit" class="btn btn-primary" [ngClass]="checkoutForm.invalid ? 'disabled': ''">{{ 'bank365.submit' | translate }}</button>
      </div>
    </div>
  </form>
</div>
